export default "__VITE_ASSET__CsWt6MC5__"